"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs3/regenerator"));

require("core-js/modules/es.number.constructor.js");

var _promise = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/promise"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/asyncToGenerator"));

var _injectIframe = _interopRequireDefault(require("../utils/injectIframe"));

var _serializeScheme = _interopRequireDefault(require("./serializeScheme"));

var _log = require("./log");

/**
 * @file invokeParsedScheme.ts 调用scheme
 * @author wangning25 <wangning25@baidu.com> on 2021/10/06.
 */

/**
 * 根据描述表过滤端能力返回的data对象
 * @param returnValues 返回的数据，不带status、message
 * @returns Object
 */
// const filterDataObject = (parsedScheme: parsedSchemeType, returnValues: callbackResponseType['data']) => {
//     if ((parsedScheme.params||{}).__skipCheck) {
//         return returnValues;
//     }
//     // 过滤后的对象
//     let filteredValue = {};
//     try {
//         const descTable = getAllDescriptionTable();
//         const {subModuleName, actionName} = parsedScheme;
//         const currentSchemeDescriptionTable = descTable[subModuleName]
//             ? (descTable[subModuleName][actionName] || {})
//             : {};
//         const currentSchemeDescriptionTableReturnValues = currentSchemeDescriptionTable.returnValues || [];
//         if(!currentSchemeDescriptionTableReturnValues.length) {
//             console.log('描述表未定义端能力返回值');
//             // TODO 后面注掉
//             filteredValue = returnValues;
//         } else {
//             if (returnValues) {
//                 // 修改returnValues.data返回数据
//                 filteredValue = currentSchemeDescriptionTableReturnValues.reduce((acc, item) => {
//                     acc[item.name] = returnValues[item.name];
//                     return acc;
//                 }, {});
//             }
//         }
//         return filteredValue;
//     } catch(e) {
//         // TODO 加打点
//         return filteredValue;
//     }
// };

/**
 * 调用格式化的scheme
 * @param parsedScheme scheme重要元素
 * @param callbackMiddleware 一级回调中间件函数
 * @returns {Promise<callbackResponseType>}
 */
var invokeParsedScheme = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(parsedScheme, callbackMiddleware) {
    var scheme;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            scheme = (0, _serializeScheme.default)(parsedScheme);
            return _context.abrupt("return", new _promise.default(function (resolve, reject) {
              var _parsedScheme$params;

              // scheme非空判断
              // if(!scheme) {}
              // 监控采集
              var monitor = {
                start: 0,
                end: 0,
                scheme: scheme,
                errno: 0,
                errmsg: '',
                data: {}
              };

              var resolveP = function resolveP(data) {
                // 修改了端能力返回值里的data字段
                // data.data = filterDataObject(parsedScheme, data.data);
                // 先resolve再发统计
                resolve(data);
                monitor.end = Date.now();
                monitor.errno = data.status;
                monitor.errmsg = data.message;
                monitor.data = data.data || {};
                (0, _log.send_log_4951_event)(monitor);
              }; // 正常响应，


              // 正常响应，
              window[parsedScheme.callbackName] = function (res) {
                var data = res;

                try {
                  data = typeof res === 'string' ? JSON.parse(decodeURIComponent(res)) : res;
                  data.status = Number(data.status);
                } catch (error) {
                  // TODO: 错误上报
                  return resolveP({
                    status: 10500,
                    message: "Internal Client Error:".concat(error.message),
                    data: res
                  });
                } // 一级回调的处理-第二种情况 callback middleware


                // 一级回调的处理-第二种情况 callback middleware
                if (typeof callbackMiddleware === 'function') {
                  callbackMiddleware(data, function (finalData) {
                    delete window[parsedScheme.callbackName];
                    resolveP(finalData || data);
                  }); // 一级回调的处理-第一种情况
                } else {
                  delete window[parsedScheme.callbackName];
                  resolveP(data);
                }
              }; // timeout


              // timeout
              if ((_parsedScheme$params = parsedScheme.params) !== null && _parsedScheme$params !== void 0 && _parsedScheme$params.timeout) {
                setTimeout(function () {
                  resolveP({
                    status: 10504,
                    message: 'Client Gateway Timeout',
                    data: null
                  });
                }, parsedScheme.params.timeout);
              } // 端能力请求


              // 端能力请求
              monitor.start = Date.now();
              (0, _injectIframe.default)(scheme);
            }));

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function invokeParsedScheme(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var _default = invokeParsedScheme;
exports.default = _default;